<template>
    <section id="" >
      <div class="container">
          <div class="dasboard-content" >
            <div class="tittle">
              <h3>Disclaimer</h3>
            </div>
            <div class="content" v-if="userLocation !== null && userLocation !== 'US'"> 
              <p>
                The financial statements translation provided by us is based on information provided and entered by the user which is believed to be accurate and reliable. We cannot independently verify or validate information entered by the user.
              </p>
              <p>
                Because of the possibility of human, technical or mechanical error, all information is presented "as is" without any warranty of any kind. No warranty, express or implied, as to the accuracy, timeliness or completeness is given or made by us, directly or indirectly, in any form or manner whatsoever.
              </p>
              <p>
                To the extent permitted by law, our employees and officers disclaim liability to any person or entity for any direct, indirect, special, consequential, incidental or compensatory losses, loss of present or future revenue or profits, or any damages whatsoever arising from or in connection with the use, or inability to use, the information contained in the financial statement translations.
              </p>
              <p>
                To the extent permitted by law, our employees and officers disclaim liability to any person or entity for any damages caused by negligence on our part or any contingency within or out of control of our employees and officers.
              </p>
            </div>
            <div class="content" v-if="userLocation !== null &&  userLocation === 'US'">
              <p> Disclaimer for US citizens</p>
            </div> 
          </div>
      </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
  data: function () {
    return {
      userLocation: null
    }
  },
  methods: {
    async ipLookUp () {
    const response = await axios.get('http://ip-api.com/json')
    this.userLocation = response.data.countryCode
    // console.log('this.userLocation', this.userLocation)

}
  },
  created () {
    this.ipLookUp()
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/disclaimer.vue